import { eSSSection } from './eSSSection';
import { SSSection } from './SSSection';
import { v4 as uuid } from 'uuid';
import { getSSSectionLabel } from './GetSSSectionLabel';
import { getSSSectionOrder } from './getSSSectionOrder';
import { eTransactionCategory } from '../enums/eTransactionType';
import { IAPIFeeData } from '../../types/clientPortal/Fees/IAPIFee';

export const getSSSectionsForIAPIFeeData = (
  items: IAPIFeeData[],
  transactionType: eTransactionCategory
): SSSection[] => {
  const sections: SSSection[] = Object.values(eSSSection).map((section) => ({
    id: uuid(),
    type: section,
    label: getSSSectionLabel(section as eSSSection),
    order: getSSSectionOrder(section, transactionType),
    items: [],
  }));

  items.forEach((item) => {
    const section = sections.find((s) => s.type === item.ssSection);
    if (section) {
      section.items.push({
        ...item,
        ssLabel: item.ssLabel,
        order: item.ssFeeOrder,
      });
    } else {
      console.error('Invalid Fee ', item, ' section type. Section ', item.ssSection);
    }
  });

  return sections.filter((section) => section.label && section.items.length > 0);
};
